import React, { useState } from "react";

const MediaPostCard = ({ post, onShare }) => {
  const [iframeLoading, setIframeLoading] = useState(true);

  return (
    <div className="media-grid-item">
      <div className="media-post-card">
        {/* 1. Header with Category Badge & LinkedIn link */}
        <div className="media-card-header">
          <span className="media-post-category-tag">
            {post.category || "Company Update"}
          </span>

          <a
            href={post.postUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="media-linkedin-tag"
            title="Open on LinkedIn"
            aria-label="Open on LinkedIn"
          >
            <i className="fa-brands fa-linkedin"></i>
          </a>
        </div>

        {/* 2. Actual Official LinkedIn Embedded Post - Uniform Fixed Height */}
        <div className="media-iframe-container">
          {iframeLoading && (
            <div className="media-iframe-skeleton">
              <div className="spinner-border text-primary spinner-border-sm" role="status"></div>
              <span>Loading live LinkedIn post...</span>
            </div>
          )}
          <iframe
            src={post.embedUrl}
            title={post.title || `LinkedIn Post ${post.id}`}
            className="media-actual-iframe"
            frameBorder="0"
            allowFullScreen=""
            loading="lazy"
            onLoad={() => setIframeLoading(false)}
          ></iframe>
        </div>

        {/* 3. Action Footer */}
        <div className="media-card-footer">
          <a
            href={post.postUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="media-btn-linkedin"
          >
            <i className="fa-brands fa-linkedin"></i>
            <span>View on LinkedIn</span>
          </a>

          <button
            type="button"
            className="media-btn-share"
            onClick={() => onShare(post)}
            title="Copy Post Link"
            aria-label="Copy post link"
          >
            <i className="fa-solid fa-share-nodes"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MediaPostCard;
